/**
 * The ES function Array.prototype.includes() is typed to only accept a search element
 * whose type is assignable to the array's type. This is counterproductive in cases where
 * you just don't know, which type your search element has.
 *
 * Use with care! Often, this is a workaround for a logical problem.
 */
export function arrayIncludesUnknown<T>(array: readonly T[], searchElement: unknown): searchElement is T {
  // @ts-expect-error -- It's fine to search for an element of unknown type: It's either contained or not
  return array.includes(searchElement);
}
